import { Component } from '@angular/core';

@Component({
  selector: 'lp2-password-setup-page',
  templateUrl: './password-setup-page.component.html',
  styleUrls: ['./password-setup-page.component.scss']
})
export class PasswordSetupPageComponent {

  constructor() { }

}



// WEBPACK FOOTER //
// ./ts/app/login/password-setup-page/password-setup-page.component.ts